import Nav from "./components/Nav";

import Cart from "./components/Cart";
import { useState } from "react";
import ProductContainer from "./components/productContainer";

export default function Layout() {
    let [showProductOrCart, setShowProductOrCart] = useState(true);

    return (
        <>
            <Nav
                showProductOrCart={showProductOrCart}
                handleChange={setShowProductOrCart}
            />

            <main className="py-16">
                {showProductOrCart ? <ProductContainer /> : <Cart />}
            </main>
        </>
    );
}
